export default __webpack_public_path__ + "a42890877f1969bfeb8ba6611fd20724.png";